module.exports = __webpack_public_path__ + "media/gallery/photo12-6b1fecad.webp";